import { SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata'

export const seoDefaults: SEOMetadataProps = {
  title: 'Online Startup Accelerator',
  noIndex: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production',
  noFollow: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production',
  imageUrl: 'https://s3.amazonaws.com/app-assets.startups.com/share-default-min.jpg',
  description:
    'Launch your startup without giving up any equity. Grow with help from Startup Advisors backed by a community of founders.',
  facebookAppId: '1858686837721825',
  twitterHandle: '@startupscom',

  type: 'website',

  additionalLinkTags: [
    {
      rel: 'sitemap',
      type: 'text/html',
      href: '/sitemaps',
    },
    {
      rel: 'sitemap',
      type: 'application/xml',
      title: 'Sitemap',
      href: '/api/sitemap.xml',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '57x57',
      href: '/assets/meta/apple-touch-icon-57x57.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '60x60',
      href: '/assets/meta/apple-touch-icon-60x60.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '72x72',
      href: '/assets/meta/apple-touch-icon-72x72.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '76x76',
      href: '/assets/meta/apple-touch-icon-76x76.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '114x114',
      href: '/assets/meta/apple-touch-icon-114x114.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '120x120',
      href: '/assets/meta/apple-touch-icon-120x120.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '144x144',
      href: '/assets/meta/apple-touch-icon-144x144.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: '/assets/meta/apple-touch-icon-152x152.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/assets/meta/apple-touch-icon-180x180.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/assets/meta/favicon-32x32.png',
      sizes: '32x32',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/assets/meta/android-chrome-192x192.png',
      sizes: '192x192',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/assets/meta/favicon-96x96.png',
      sizes: '96x96',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/assets/meta/favicon-16x16.png',
      sizes: '16x16',
    },
    {
      rel: 'shortcut icon',
      href: '/assets/meta/favicon.ico',
    },
    {
      rel: 'manifest',
      href: '/metadata/sco/manifest.json',
    },
  ],

  additionalMetaTags: [
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-title', content: 'Startups.com' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    {
      name: 'viewport',
      content: 'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1',
    },
    // { name: 'format-detection', content: 'telephone=no' },
  ],
}
